import * as React from "react";

function SvgSupport({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M16.815 3.523l.124-.063a1.756 1.756 0 011.86.24l.12.11 1.272 1.273c.575.575.662 1.44.286 2.104a9.744 9.744 0 010 9.63c.35.617.297 1.411-.178 1.982l-.109.12-1.273 1.272a1.754 1.754 0 01-2.103.287 9.747 9.747 0 01-9.63-.001 1.755 1.755 0 01-1.983-.178l-.12-.109-1.272-1.273a1.754 1.754 0 01-.287-2.103 9.75 9.75 0 010-9.63A1.755 1.755 0 013.7 5.201l.109-.12L5.082 3.81a1.754 1.754 0 012.103-.287 9.75 9.75 0 019.34-.158l.29.16zM9.892 17.37L8.26 19.353a8.252 8.252 0 007.48.001l-1.634-1.984a5.783 5.783 0 01-4.214 0zm6.186-1.292a5.828 5.828 0 01-.64.553l2.045 2.481c.081.1.22.12.325.057l.049-.038 1.272-1.273a.254.254 0 00.025-.329l-.043-.045-2.482-2.044c-.165.223-.35.436-.551.638zm-8.708-.639l-2.482 2.044c-.1.081-.12.22-.057.325l.038.049 1.273 1.272c.09.09.231.097.329.025l.045-.043L8.56 16.63a5.789 5.789 0 01-1.19-1.19zm1.613-6.456a4.265 4.265 0 000 6.034 4.266 4.266 0 006.19-5.87l-.156-.164-.164-.156a4.266 4.266 0 00-5.87.156zm10.37-.721L17.37 9.894a5.78 5.78 0 010 4.213l1.984 1.633a8.254 8.254 0 000-7.478zM4.647 15.738l1.984-1.632a5.783 5.783 0 010-4.214L4.646 8.26a8.254 8.254 0 000 7.478zM17.53 4.846l-.045.043-2.043 2.482a5.873 5.873 0 011.189 1.19l2.482-2.044c.1-.081.12-.22.057-.325l-.038-.049-1.273-1.272a.254.254 0 00-.329-.025zM6.191 4.83l-.049.038L4.87 6.142a.254.254 0 00-.025.329l.043.045L7.37 8.56a5.789 5.789 0 011.19-1.19L6.516 4.888a.251.251 0 00-.325-.057zm2.069-.185L9.893 6.63a5.783 5.783 0 014.214 0l1.633-1.983a8.248 8.248 0 00-7.48 0z"
        />
      </g>
    </svg>
  );
}

export default SvgSupport;
